export const SET_FABRIC_TEMPLATE = '/Template/*/Set';
export const SET_TEMPLATE_SNAPSHOT = '/Template/*/SNAPSHOT';

export const TEMPORARY_STAMP_ASSET_ORDERING = [
  /**
   * In lieu of easy access to asset ids we will use asset display
   * names as unique identifiers arrayed in the expected order
   */

  // Valentine's Day
  'Red Heart',
  'Conversation Hearts',
  'Handwritten Love You',
  'Ily',
  'Kissed on Paper',
  'Love You', // not in Vday section?
  'Love You Cutout',
  'Sweet Heart',
  'Triple Heart',
  'Triple heart',
  'Heart Chocolate',
  'Gold Cutout Heart',
  'Gold Love Heart',
  'Rose Gold Ribbon',
  'Typographic Love',

  'Happy Happy Happy',
  'Black Candles',
  'Party Pennant',
  'Party Hats',
  'Birthday Cake',
  'Gold HBD and Confetti',
  'Pop Art Stars',
  'Moon and Stars',
  'Pastel Rainbow',
  'Happy Cloud',
  'Peek-A-Boo Bear',
  'Jumping for Joy',
  'Shooting Star',
  'Sticker Collage',
  'Baby Sprinkles',
  'Gold Crown',
  'Watercolor Wildflowers',
  'Green Sprig',
  'Party Gold',
  'Hedgehog',
  'Ocean Waves',
  'Bright Rainbow',
  "You're Invited Scalloped Border",
  'Heart Chocolate',
  'Retro Flowers',

  'Graduation Cap',
  'Fireworks',
  'Flower Garden',
  'Ombré Lightning Bolt',
  'Pink-Purple Stars',
  'Red Celebrate',
  'Retro Rainbow Stars',
  'Neon Cocktail',
  'Gold Cheers',
  'Smiley Face',
  'Comic Book Boom',
  'Victorian Garden',
  'Watercolor Greenery',
  'Typographic Love',
  'Happy Face',

  'Gold Love Heart',
  'Diamond Engagement Ring',
  'Pink Rose',
  'Champagne and Confetti',
  "Blue You're Invited",
  'Single Diamond',
  "Gold and Ivory You're Invited",
  'Rose Gold Ribbon',
  'Gold Cutout Heart',

  // Halloween
  'After Life Skulls',
  'Black Cat Tomb',
  'Pick Your Poison',
  'Spooky Bat',
  'Faboolous',
  'Boo!',

  // Holiday
  'Beary Happy Holiday',
  'Gold Joy',
  'Holiday Trees',
  'Top Hat Snowman',
  'Fa La La',
  'Dove of Peace',
  'Fair Isle Holiday Bell',
  'Menorah',
  'Star of David',

  // Keep default at the end
  'Evite',
];

export const TEMPORARY_STICKER_ASSET_ORDERING = [
  /**
   * In lieu of easy access to asset ids we will use asset display
   * names as unique identifiers arrayed in the expected order
   */

  // Valentine's Day
  'Galentine',
  'Love',
  'Rosés',
  'So Sweet',
  'XOXO',

  // Superbowl
  'Beers (Dark Outline)',
  'Fire Football',
  'Foam Finger (Outline)',
  'Game On',
  'Super',
  'Super Bowl Trophy',

  // Spring
  'Best in Bloom',
  'Butterfly',
  'Spring Has Sprung',
  'Pink Tulip',
  "Rise'n Shine",
  'Easter Hatch',
  'Hop on Over',
  'Hoppy Bee',
  'Hop to See You',
  'Somebunny',

  // Generic?
  'Colorful Balloons',
  "Can't Wait",
  'Click',
  'Conga',
  'IYKYK',
  'New',
  'New Post',
  'Party!!!',
  'Pointing',
  'Smile',
  'Swipe Up',
  'Tap Here',
  'Wave',
  "You're Invited",

  // Wedding
  'Bride Sash',
  'Bridesmaid Sash',
  'Wedding Cake',
  'Margarita',
  'Wedding Veil',

  // Mother's Day
  'Heart',
  'Love You',
  'Ribbon',
  'Rose and Bud',
  "Mother's Day Trophy",
  "Mother's Day Type",

  // Pride
  'Happy Pride',
  'Pride Heart',
  'Love Is Love',
  'Love Wins',
  'Pride',

  // Halloween
  'Bat',
  'Candy Corn',
  'Faboolous',
  'Ghost',
  'Hocus Pocus',
  'Pumpkin',
  'Skeleton',
  'Trick or Treat',

  // Thanksgiving
  'Give Thanks',
  'Gratitude',
  'Oh My Gourd',
  'Thanks a Latte',
  'Turkey',

  // Holiday
  'Blushing Snowflake',
  'Cool Snowflake',
  'Gift Box',
  'Ho Ho Ho',
  'Jumping Snowman',
  'Merry Vibes',
  'Peace Love',
  'Spinning Ornament',
  'Surfer Reindeer',
  'Xmas Palm Tree',
];

export const TEMPORARY_LINER_ASSET_ORDERING = [
  /**
   * In lieu of easy access to asset ids we will use asset display
   * names as unique identifiers arrayed in the expected order
   */

  'Party Balloons',
  'Metallic Confetti',
  'Colorful Confetti on White',
  'Glitter Gradient',
  'Retro Geometric Confetti',
  'Gold Stars on Black',
  'Pop Art Stars',
  'Pompom Party Hats',
  'Rainbow Colorful Stripes',
  'Floating Balloons',
  'Ribbon Confetti on Gold',
  'Colorful Confetti on Cream',
  'Blue Grid',
  'Pastel Stripes',
  'Hearts and Stars Shapes',
  'Hearts and Flourishes',
  'Textured Stars',
  'Wildflowers',
  'Teal Gradient',
  'Pink and Gold Hearts',
  'Colorful Raindrops',
  'Restful Pastel Stars',
  'Daisies',
  'Blue and Pink Flowers',
  'Rainbow Brushstroke',
  'Pink and Orange Hearts',
  'Golden Leaves',
  'Silver Disco',
  'Red Grid',
  'Squiggly Confetti',
  'Rainbow Gradient',
  'Gold Foil Stars',
  'Rustic Stripes',
  'Pastel Gradient',
  'Gradient Stars',
  'Field of Daisies on Blue',
  'Smiley Face',
  'Purple Watercolor',
  'Green Watercolor',
  'Pink Watercolor',
  'Gradient Rainbow Hearts',
  'Grey Harlequin Pattern',
  'Gold Fireworks',
  'Field of Daisies on Green',
  'Wavy Colorful Lines',
  'Watercolor Plants',
  'Blue and Pink Grid',
  'Superhero Pop Art',
  'Palm Trees on Pink',
  'Butterflies and Flowers',
  'Gold Glitter',
  'Gold Polka Dots',
  'Gold Stripes',
  'Gold Light Rays',
  'Rose Gold',
  'Gold Confetti',
  'Silver Soirée',
  'Gold Soirée',
  'Bronze Soirée',
  'Gold and Silver Stars',
  'Gold Loops',
  'With Love',
  'Gold String Lights',

  // Halloween
  'Black Cat',
  'Grey Pumpkins',
  'Halloween Feast',
  'Candy Corn',
  'Witching Hour',
  'Spooky Bats',

  // Holiday
  'Green Pine',
  'Holiday Stars',
  'Retro Snowflakes',
  'Holiday Confetti',
  'Holiday String Lights',
  'Ivory Pine',
  'Beige Star of David',
  'Colorful Retro Starbursts',
  'Night Sky',
  'Colorful Twinkling Stars',
  'Holiday Trees',
  'Gold Star of David',
  'Holly Berries',
];
